import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import VisibleOn from '../visibleOn/VisibleOn';
import styles from './Menu.module.scss';
import copy from '../../../../content/copy';

class Menu extends React.PureComponent {
    static defaultProps = {
        selected: '',
        fixedBottom: false,
        submenu: false,
    };

    static propTypes = {
        links: PropTypes.arrayOf(PropTypes.string).isRequired,
        selected: PropTypes.string,
        submenu: PropTypes.bool,
        fixedBottom: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this.links = this.props.links.map(value => ({
            ...copy.nav[value],
            id: value,
        }));
        this.state = { menuOpen: false };
    }

    onMenuClicked() {
        this.setState({ menuOpen: !this.state.menuOpen });
    }

    _getLink = (value, selected) => {
        const classnameLink = [styles.link];
        const { submenu } = this.props;

        if (selected === value.id) {
            if (submenu) classnameLink.push(styles['sub-menu']);
            else {
                return (
                    <div
                        className={[styles.link, styles['link-selected']].join(
                            ' '
                        )}
                    >
                        <p className={styles.p}>{value.title}</p>
                    </div>
                );
            }
        }

        return (
            <Link className={classnameLink.join(' ')} to={value.link}>
                <p className={styles.p}>{value.title}</p>
            </Link>
        );
    };

    _getLinks() {
        const links = this.links.map(value => (
            <li key={value.id} className={styles['single-button']}>
                {this._getLink(value, this.props.selected)}
            </li>
        ));
        return links;
    }

    _desktopMenu() {
        return (
            <VisibleOn
                visibleOn={this.props.fixedBottom ? 'all' : 'not-mobile'}
            >
                <div
                    className={[
                        styles.menu,
                        styles[
                            this.props.fixedBottom
                                ? 'landing-layout'
                                : 'regular-layout'
                        ],
                    ].join(' ')}
                >
                    <ul className={styles['button-layout']}>
                        {this._getLinks()}
                    </ul>
                </div>
            </VisibleOn>
        );
    }

    _mobileMenu() {
        const { menuOpen } = this.state;
        if (!this.props.fixedBottom)
            return (
                <VisibleOn visibleOn="mobile">
                    <div
                        className={[
                            styles['menu-mobile-button'],
                            menuOpen ? styles.open : '',
                        ].join(' ')}
                        role="presentation"
                        onClick={() => {
                            this.onMenuClicked();
                        }}
                    />
                    <div className={styles['menu-mobile-wrapper']}>
                        <div
                            className={[
                                styles['menu-mobile'],
                                menuOpen ? styles.open : '',
                            ].join(' ')}
                            role="presentation"
                            onClick={() => {
                                this.onMenuClicked();
                            }}
                        >
                            <ul className={styles['button-layout']}>
                                {this._getLinks()}
                            </ul>
                        </div>
                    </div>
                </VisibleOn>
            );
        return null;
    }

    render() {
        return (
            <React.Fragment>
                {this._desktopMenu()}
                {this._mobileMenu()}
            </React.Fragment>
        );
    }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/common/menu/Menu.jsx